
<template>
  <!-- Modale per la creazione e la modifica delle campagne -->
  <b-modal
    v-model="open_close_modal"
    :title="is_modifica ? 'Modifica campagna' : 'Nuova campagna'"
    size="lg"
    :no-close-on-backdrop="salvataggio_in_corso"
    :no-close-on-esc="salvataggio_in_corso"
    :hide-header-close="salvataggio_in_corso"
    @show="resetta_modale"
  >
    <!-- Descrizione della campagna -->
    <b-form-group
      label="* Descrizione"
      :state="form_state.descrizione"
      :invalid-feedback="form_feedback.descrizione"
    >
      <b-form-input
        v-model="campagna_form.descrizione"
        type="text"
        placeholder="Inserire la descrizione della campagna"
        :state="form_state.descrizione"
        :disabled="salvataggio_in_corso"
      />
    </b-form-group>
    <!-- Periodo della campagna -->
    <b-row>
      <b-col cols="12" md="6">
        <b-form-group
          label="* Data inizio"
          :state="form_state.data_inizio"
          :invalid-feedback="form_feedback.data_inizio"
        >
          <b-form-datepicker
            v-model="campagna_form.data_inizio"
            :max="campagna_form.data_fine || undefined"
            placeholder="Scegli una data"
            locale="it"
            :state="form_state.data_inizio"
            :disabled="salvataggio_in_corso"
          />
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6">
        <b-form-group
          label="* Data fine"
          :state="form_state.data_fine"
          :invalid-feedback="form_feedback.data_fine"
        >
          <b-form-datepicker
            v-model="campagna_form.data_fine"
            :min="campagna_form.data_inizio || undefined"
            :max="campagna_form.data_inizio
              ? campagna_form.data_inizio.substring(0, 4) + '-12-31'
              : undefined"
            reset-button
            reset-button-variant="outline-secondary"
            placeholder="Scegli una data"
            locale="it"
            :state="form_state.data_fine"
            :disabled="salvataggio_in_corso"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <!-- Scadenza risposta e maggiorazione welfare -->
    <b-row>
      <b-col cols="12" md="6">
        <b-form-group
          label="* Scadenza risposta"
          :state="form_state.data_scadenza_risposta"
          :invalid-feedback="form_feedback.data_scadenza_risposta"
        >
          <b-form-datepicker
            v-model="campagna_form.data_scadenza_risposta"
            :min="campagna_form.data_inizio || undefined"
            :max="campagna_form.data_fine || undefined"
            placeholder="Scegli una data"
            locale="it"
            :state="form_state.data_scadenza_risposta"
            :disabled="salvataggio_in_corso"
          />
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6">
        <b-form-group
          label="* Maggiorazione welfare (%)"
          :state="form_state.percentuale_maggiorazione"
          :invalid-feedback="form_feedback.percentuale_maggiorazione"
        >
          <b-form-input
            v-model="campagna_form.percentuale_maggiorazione"
            type="number"
            min="0"
            step="0.01"
            placeholder="Inserire la percentuale"
            :state="form_state.percentuale_maggiorazione"
            :disabled="salvataggio_in_corso"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <!-- Motivo obbligatorio per la modifica della campagna -->
    <b-form-group
      v-if="is_modifica"
      label="* Motivo della modifica"
      :state="form_state.motivo"
      :invalid-feedback="form_feedback.motivo"
    >
      <b-form-textarea
        v-model="campagna_form.motivo"
        placeholder="Inserire il motivo della modifica"
        rows="3"
        :state="form_state.motivo"
        :disabled="salvataggio_in_corso"
      />
    </b-form-group>
    <!-- Pulsanti della modale -->
    <template #modal-footer>
      <b-button
        variant="primary"
        :disabled="salvataggio_in_corso"
        @click="salva_campagna"
      >
        <b-spinner v-if="salvataggio_in_corso" small class="mr-2" />
        {{ is_modifica ? "Salva modifiche" : "Salva campagna" }}
      </b-button>
      <b-button
        variant="secondary"
        :disabled="salvataggio_in_corso"
        @click="open_close_modal = false"
      >
        Annulla
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import axios from "axios";
import { apiUrl } from "@/apiUrl";
import { generalLib } from "@/generalLib";

export default {
  name: "CampagnaModal",

  model: {
    prop: "show_modal",
    event: "close"
  },

  props: {
    show_modal: { type: Boolean, default: false },
    // Campagna da modificare; null indica una nuova campagna.
    campagna: { type: Object, default: null }
  },

  data() {
    return {
      // Indica se è in corso il salvataggio della campagna.
      salvataggio_in_corso: false,

      // Dati del formulario per la creazione o modifica della campagna.
      campagna_form: {
        descrizione: "",
        data_inizio: null,
        data_fine: null,
        data_scadenza_risposta: null,
        percentuale_maggiorazione: null,
        motivo: ""
      },

      // Stati di validazione dei campi.
      form_state: {
        descrizione: null,
        data_inizio: null,
        data_fine: null,
        data_scadenza_risposta: null,
        percentuale_maggiorazione: null,
        motivo: null
      },

      // Messaggi di errore dei campi.
      form_feedback: {
        descrizione: "",
        data_inizio: "",
        data_fine: "",
        data_scadenza_risposta: "",
        percentuale_maggiorazione: "",
        motivo: ""
      }
    };
  },

  computed: {
    // Gestisce l'apertura e la chiusura della modale tramite il componente padre.
    open_close_modal: {
      get() {
        return this.show_modal;
      },
      set(value) {
        this.$emit("close", value);
      }
    },

    // Indica se la modale è utilizzata per modificare una campagna esistente.
    is_modifica() {
      return this.campagna !== null;
    }
  },

  watch: {
    "campagna_form.data_inizio"(nuova_data) {
      // Aggiorna la data fine al 31 dicembre dell'anno della data inizio.
      if (nuova_data) {
        this.campagna_form.data_fine =
          nuova_data.substring(0, 4) + "-12-31";
      }
    }
  },

  methods: {
    // Inizializza i campi a ogni apertura della modale.
    resetta_modale() {
      this.salvataggio_in_corso = false;

      // In modifica utilizza i dati della campagna selezionata.
      // In creazione inizializza i campi vuoti.
      this.campagna_form = {
        descrizione: this.is_modifica ? this.campagna.descrizione : "",
        data_inizio: this.is_modifica ? this.campagna.data_inizio : null,
        data_fine: this.is_modifica ? this.campagna.data_fine : null,
        data_scadenza_risposta: this.is_modifica ? this.campagna.data_scadenza_risposta : null,
        percentuale_maggiorazione: this.is_modifica ? this.campagna.percentuale_maggiorazione : null,
        motivo: ""
      };

      // Azzera gli stati di validazione.
      Object.keys(this.form_state).forEach((campo) => {
        this.form_state[campo] = null;
        this.form_feedback[campo] = "";
      });
    },

    // Verifica i campi obbligatori e la coerenza dei dati della campagna.
    valida_campagna() {
      const campagna = this.campagna_form;

      // Reinizializza gli stati e i messaggi di errore.
      Object.keys(this.form_state).forEach((campo) => {
        this.form_state[campo] = true;
        this.form_feedback[campo] = "";
      });

      // Descrizione obbligatoria.
      if (!campagna.descrizione.trim()) {
        this.form_state.descrizione = false;
        this.form_feedback.descrizione = "Inserire la descrizione della campagna.";
      }

      // Date obbligatorie.
      if (!campagna.data_inizio) {
        this.form_state.data_inizio = false;
        this.form_feedback.data_inizio = "Inserire la data di inizio.";
      }

      if (!campagna.data_fine) {
        this.form_state.data_fine = false;
        this.form_feedback.data_fine = "Inserire la data di fine.";
      }

      if (!campagna.data_scadenza_risposta) {
        this.form_state.data_scadenza_risposta = false;
        this.form_feedback.data_scadenza_risposta = "Inserire la scadenza risposta.";
      }

      // Coerenza del periodo della campagna.
      if (campagna.data_inizio && campagna.data_fine &&
          campagna.data_inizio > campagna.data_fine) {
        this.form_state.data_inizio = false;
        this.form_feedback.data_inizio = "La data di inizio non può essere successiva alla data di fine.";
        this.form_state.data_fine = false;
        this.form_feedback.data_fine = "La data di fine non può essere precedente alla data di inizio.";
      }

      // Scadenza risposta compresa nel periodo della campagna.
      if (campagna.data_scadenza_risposta && campagna.data_inizio &&
          campagna.data_fine &&
          (campagna.data_scadenza_risposta < campagna.data_inizio ||
           campagna.data_scadenza_risposta > campagna.data_fine)) {
        this.form_state.data_scadenza_risposta = false;
        this.form_feedback.data_scadenza_risposta =
          "La scadenza risposta deve essere compresa tra la data di inizio e la data di fine.";
      }

      // Percentuale obbligatoria e non negativa.
      const percentuale = campagna.percentuale_maggiorazione;

      if (percentuale === null || percentuale === "") {
        this.form_state.percentuale_maggiorazione = false;
        this.form_feedback.percentuale_maggiorazione = "Inserire la percentuale di maggiorazione.";
      } else if (!Number.isFinite(Number(percentuale)) || Number(percentuale) < 0) {
        this.form_state.percentuale_maggiorazione = false;
        this.form_feedback.percentuale_maggiorazione = "Inserire una percentuale valida e non negativa.";
      } else if (!/^\d+(\.\d{1,2})?$/.test(String(percentuale))) {
        this.form_state.percentuale_maggiorazione = false;
        this.form_feedback.percentuale_maggiorazione = "Inserire al massimo due cifre decimali.";
      }

      // Motivo obbligatorio solamente in caso di modifica.
      if (this.is_modifica && !campagna.motivo.trim()) {
        this.form_state.motivo = false;
        this.form_feedback.motivo = "Inserire il motivo della modifica.";
      }

      return Object.values(this.form_state).every(stato => stato === true);
    },

    // Valida i dati e crea o modifica la campagna tramite API.
    async salva_campagna() {
      if (this.salvataggio_in_corso || !this.valida_campagna()) {
        return;
      }

      this.salvataggio_in_corso = true;

      try {
        // In modifica invia il motivo e aggiorna la campagna selezionata.
        // In creazione invia solamente i campi previsti dal serializer.
        const { motivo, ...dati_campagna } = this.campagna_form;
        let response;

        if (this.is_modifica) {
          response = await axios.put(
            `${apiUrl.conversionepremioapi.campagne}${this.campagna.id}/`,
            { ...dati_campagna, motivo }
          );
        } else {
          response = await axios.post(
            apiUrl.conversionepremioapi.campagne,
            dati_campagna
          );
        }

        // Comunica al componente padre la creazione o modifica della campagna.
        this.$emit(this.is_modifica ? "campagna-modificata" : "campagna-creata", response.data);

        // Chiude la modale dopo il salvataggio.
        this.open_close_modal = false;

      } catch (error) {
        generalLib.backend_error_message_box(
          this, error.response ? error.response.data : error
        );
      } finally {
        this.salvataggio_in_corso = false;
      }
    }
  }
};
</script>
